import { Button } from '@cibli/shared';
import { CheckCircle2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import MainLayout from '@/features/common/components/MainLayout';

interface Props {
  onValidate: (paymentIntentId: string) => void;
  paymentIntentId: string;
}

export default function ValidatedPaymentScreen({ onValidate, paymentIntentId }: Props) {
  const { t } = useTranslation();

  return (
    <MainLayout className="gap-12 sm:gap-20">
      <CheckCircle2 className="size-16 text-green-600" />

      <div className="space-y-2 max-w-md text-center">
        <h3 className="text-lg font-semibold text-gray-900">
          {t('FormScreen.ValidatedPayment.title')}
        </h3>
        <p className="text-sm text-gray-600">{t('FormScreen.ValidatedPayment.message')}</p>
      </div>

      <Button size="lg" onClick={() => onValidate(paymentIntentId)} className="mt-6">
        {t('FormScreen.ValidatedPayment.continue')}
      </Button>
    </MainLayout>
  );
}
